import React from 'react';
import PropTypes from 'prop-types';
import Wizard from '../partials/Wizard';
import MapPlanCalculator from '../partials/MapPlanCalculator';
import DataPlanCalculator from '../partials/DataPlanCalculator';
import CanvassingPlanCalculator from '../partials/CanvassingPlanCalculator';
import SubscriptionCheckout from '../partials/SubscriptionCheckout';
import Select from 'react-select';
import { Row, Col } from 'react-bootstrap';
import { fetchFeaturePlans, fetchRegionGeoJson } from 'api';
import { LoadingSpinner, WidgetSummary, ConfirmationPrompt } from 'components';
import computeDiscount from '../../utils/computeDiscount';

const Icon = (props) => (
  <div style={{
    width: 45,
    height: 45,
    borderRadius: 45,
    textAlign: 'center',
    paddingTop: 11,
    color: props.color || '#ffffff',
    borderColor: props.color,
    backgroundColor: '#ffffff',
    ...(props.style || {})
  }} className={props.className}>
    <i className={`fa fa-${props.name}`}></i>
  </div>
)

class PlanCalculator extends React.Component {
  state = {
    map_interval: '',
    selected_map_city_regions: [],
    selected_map_state_regions: [],
    selected_map_national_plan: false,
    geo_json_data: [],
    old_selected_map_city_regions: [],      //
    old_selected_map_state_regions: [],     //  For backtracking
    last_added_region_type: '',             //
    old_geo_json_data: [],                  //
    data_items: [],
    canvassing_items: [],
    total: 0,
    currentStep: 0,
    map_regions: [],
    fetching_data: true,
    updating: false,
    show_force_national_plan_prompt: false
  }
  constructor(props) {
    super(props);

    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.handleIntervalChange = this.handleIntervalChange.bind(this);
    this.handleStepChange = this.handleStepChange.bind(this);
    this.addGeoJson = this.addGeoJson.bind(this);
    this.removeGeoJson = this.removeGeoJson.bind(this);
    this.handleMapRegionsChange = this.handleMapRegionsChange.bind(this);
    this.handleSelectNationalPlan = this.handleSelectNationalPlan.bind(this);
    this.handleForceNationalPlan = this.handleForceNationalPlan.bind(this);
    this.confirmNationalPlan = this.confirmNationalPlan.bind(this);
    this.calculateTotal = this.calculateTotal.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);

    this.mounted = false;
  }
  handleQuantityChange(plan, value) {
    if(!value.startsWith('-') && +value >= 0) {
      const state_key = `${plan.type}_items`;
      const found_item = this.state[state_key].find(item => item.plan.name == plan.name);
      if(found_item) {
        if(value == 0) {
          this.setState({
            [state_key]: this.state[state_key].filter(item => item.plan.name != plan.name)
          });
        }
        else {
          this.setState({
            [state_key]: this.state[state_key].map(item => item.plan.name == plan.name ? { ...item, quantity: value } : item)
          });
        }
      }
    }
  }
  handleIntervalChange(interval, plan) {
    const state_key = `${plan.type}_items`;
    const current_plan = this.props.plans.find(p => p.interval == interval && p.name == plan.name);
    const plan_in_state = this.state[state_key].find(item => item.plan.name == plan.name);
    if(plan_in_state) {
      this.setState({ [state_key]: this.state[state_key].map(item => item.plan.name == plan.name ? { ...item, plan: current_plan } : item) });
    }
    else {
      this.setState({ [state_key]: [ ...this.state[state_key], { plan: current_plan, quantity: 0 } ] });
    }
  }
  addGeoJson(path) {
    this.setState({ fetching_geo_json: true });
    fetchRegionGeoJson(path)
    .then(data => {
      if(this.mounted) {
        this.setState({
          geo_json_data: [ ...this.state.geo_json_data, data ],
          old_geo_json_data: this.state.geo_json_data,
          fetching_geo_json: false
        });
      }
    })
    .catch(e => {
      this.props.handleError(e);
      if(this.mounted) {
        this.setState({ fetching_geo_json: false });
      }
    })
  }
  removeGeoJson(name) {
    this.setState({
      geo_json_data: this.state.geo_json_data.filter(f => f.properties.name != name),
      old_geo_json_data: this.state.geo_json_data
    });
  }
  handleMapRegionsChange(regions, type /* 'map_city' | 'map_state' */) {
    if(type == 'map_city') {
      this.setState({
        selected_map_city_regions: regions,
        old_selected_map_city_regions: this.state.selected_map_city_regions,
        last_added_region_type: 'map_city'
      });
    }
    else if(type == 'map_state') {
      this.setState({
        selected_map_state_regions: regions,
        old_selected_map_state_regions: this.state.selected_map_state_regions,
        last_added_region_type: 'map_state'
      });
    }
  }
  handleStepChange(step_number) {
    this.setState({ currentStep: step_number })
  }
  handleSelectNationalPlan() {
    this.setState({ selected_map_national_plan: !this.state.selected_map_national_plan });
  }
  handleForceNationalPlan() {
    this.setState({ show_force_national_plan_prompt: true });
  }
  confirmNationalPlan(bool) {
    this.setState({
      selected_map_national_plan: bool,
      show_force_national_plan_prompt: false,
      selected_map_city_regions: this.state.last_added_region_type == 'map_city' ? this.state.old_selected_map_city_regions : this.state.selected_map_city_regions,
      selected_map_state_regions: this.state.last_added_region_type == 'map_state' ? this.state.old_selected_map_state_regions : this.state.selected_map_state_regions,
      geo_json_data: this.state.old_geo_json_data,
    });
  }
  calculateTotal() {
    const data_total = this.state.data_items
    .reduce((acc, item) => acc + (item.plan.amount * item.quantity), 0);

    const canvassing_total = this.state.canvassing_items
    .reduce((acc, item) => acc + (item.plan.amount * item.quantity), 0);

    let maps_total;
    if(!this.state.map_interval) {
      maps_total = 0;
    }
    else if(this.state.selected_map_national_plan) {
      maps_total = Number(this.props.plans.find(p => {
        return p.type == 'map_national' && p.interval == this.state.map_interval;
      }).amount || 0);
    }
    else {
      let map_city_plan = 0, map_state_plan = 0;
      if(this.state.map_interval == 'month') {
        map_city_plan = this.props.plans.find(p => p.type == 'map_city' && p.interval == 'month');
        map_state_plan = this.props.plans.find(p => p.type == 'map_state' && p.interval == 'month');
      }
      else {
        map_city_plan = this.props.plans.find(p => p.type == 'map_city' && p.interval == 'year');
        map_state_plan = this.props.plans.find(p => p.type == 'map_state' && p.interval == 'year');
      }
      const map_city_total = map_city_plan.amount * this.state.selected_map_city_regions.length;
      const map_state_total = map_state_plan.amount * this.state.selected_map_state_regions.length;

      const selected_regions = [ ...this.state.selected_map_city_regions, ...this.state.selected_map_state_regions ];
      const maps_discount = computeDiscount(selected_regions, map_city_plan, map_state_plan);

      maps_total = (map_city_total + map_state_total) - maps_discount;
    }
    const monthly_total = [ ...this.state.canvassing_items, ...this.state.data_items ]
    .filter(item => item.plan.interval == 'month')
    .reduce((acc, item) => acc + (item.plan.amount * item.quantity), 0) +
    (this.state.map_interval == 'month' ? maps_total : 0);

    const yearly_total = [ ...this.state.canvassing_items, ...this.state.data_items ]
    .filter(item => item.plan.interval == 'year')
    .reduce((acc, item) => acc + (item.plan.amount * item.quantity), 0) +
    (this.state.map_interval == 'year' ? maps_total : 0);

    return {
      maps: maps_total,
      data: data_total,
      canvassing: canvassing_total,
      total: monthly_total + yearly_total,
      month: monthly_total,
      year: yearly_total
    };
  }
  componentDidUpdate(prev_props, prev_state) {
    if(
      (prev_props.fetching_data || prev_state.fetching_data) &&
      (!this.props.fetching_data && !this.state.fetching_data)
    ) {
      if(this.props.subscriptions && this.props.subscriptions.length > 0) {
        const tmp_state = { ...this.state };
        this.props.subscriptions.forEach(subscription => {
          const { items } = subscription;
          items.forEach(item => {
            const current_plan = this.props.plans.find(p => p._id == item.plan);
            switch(current_plan.type) {
              case 'map_city': {
                tmp_state.map_interval = current_plan.interval;
                tmp_state.selected_map_city_regions = [ ...tmp_state.selected_map_city_regions, ...item.map_regions ];
                break;
              }
              case 'map_state': {
                tmp_state.map_interval = current_plan.interval;
                tmp_state.selected_map_state_regions = [ ...tmp_state.selected_map_state_regions, ...item.map_regions ];
                break;
              }
              case 'map_national': {
                tmp_state.map_interval = current_plan.interval;
                tmp_state.selected_map_national_plan = true;
                break;
              }
              case 'data': {
                tmp_state.data_items.push({ ...item, plan: current_plan });
                break;
              }
              case 'canvassing':
                tmp_state.canvassing_items.push({ ...item, plan: current_plan });
                break;
              default: {
                this.props.handleError(new Error(`Invalid item : ${item}`));
              }
            }
          });
        });

        [ ...tmp_state.selected_map_city_regions, ...tmp_state.selected_map_state_regions ].forEach(region => this.addGeoJson(region));
        this.setState({ ...tmp_state, updating: true });
      }
    }
  }
  componentDidMount() {
    this.mounted = true;
    fetchFeaturePlans()
    .then(map_regions => this.mounted ? this.setState({ map_regions, fetching_data: false }) : null)
    .catch(this.props.handleError);
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  handleCreate(monthly_items, yearly_items) {
    this.props.handleCreate(monthly_items, yearly_items)
    .then(() => this.mounted ? this.setState({ currentStep: 0 }) : null)
  }
  handleUpdate(monthly_items, yearly_items) {
    this.props.handleUpdate(monthly_items, yearly_items)
    .then(() => this.mounted ? this.setState({ currentStep: 0 }) : null)
    .catch(console.log);
  }

  render() {
    const map_plans = this.props.plans.filter(p => [ 'map_national', 'map_state', 'map_city' ].includes(p.type));
    const data_plans = this.props.plans.filter(p => p.type == 'data');
    const canvassing_plans = this.props.plans.filter(p => p.type == 'canvassing');
    const iconStyle = {
      borderWidth: 5,
      borderStyle: 'solid',
      paddingTop: 6
    };
    const fetching_data = this.props.fetching_data || this.state.fetching_data;
    const { month: monthly_total, year: yearly_total, maps: maps_total } = fetching_data ? { year: 0, month: 0 } : this.calculateTotal();

    return (
      <div className='plan-calculator-container'>
        <Row>
          <Col md={4} xs={4}>
            <WidgetSummary
              bsStyle='success'
              icon_class='fa fa-usd'
              CustomComponent={
                <div>
                  <h3 className='mb-none mt-none'>{`Monthly`}</h3>
                  <h4>{` $${(+monthly_total / 100).toFixed(2).toLocaleString()}`}</h4>
                </div>
              }
              className='mb-lg'
            />
          </Col>
          <Col md={4} xs={4}>
            <WidgetSummary
              bsStyle='success'
              icon_class='fa fa-usd'
              CustomComponent={
                <div>
                  <h3 className='mb-none mt-none'>{`Yearly`}</h3>
                  <h4>{` $${(+yearly_total / 100).toFixed(2).toLocaleString()}`}</h4>
                </div>
              }
              className='mb-lg'
            />
          </Col>
          <Col md={4} xs={4}>
            <WidgetSummary
              bsStyle='success'
              icon_class='fa fa-usd'
              CustomComponent={
                <div>
                  <h3 className='mb-none mt-none'>{`First Bill`}</h3>
                  <h4>{` $${((+monthly_total + +yearly_total) / 100).toFixed(2).toLocaleString()}`}</h4>
                </div>
              }
              className='mb-lg'
            />
          </Col>
        </Row>
        {this.props.fetching_data || this.state.fetching_data ? (
          <LoadingSpinner />
        ) : (
          <Wizard
            currentStepNumber={this.state.currentStep}
            onClick={this.handleStepChange}
            steps={[
              {
                titleComponent: (
                  <Icon
                    color={this.state.currentStep == 0 ? '#2AD915' : '#aaaaaa' }
                    style={{
                      ...iconStyle,
                      ...(
                        this.state.currentStep > 0 ?
                        {
                          color: '#ffffff',
                          borderColor: '#2AD915',
                          backgroundColor: '#2AD915'
                        } : {
                          backgroundColor: '#ffffff'
                        }
                      )
                    }}
                    name='map'
                  />
                ),
                bodyComponent: (
                  <MapPlanCalculator
                    plans={map_plans}
                    map_regions={this.state.map_regions}
                    map_interval={this.state.map_interval}
                    maps_total={maps_total}
                    handleIntervalChange={map_interval => this.setState({ map_interval })}
                    handleMapRegionsChange={this.handleMapRegionsChange}
                    handleSelectNationalPlan={this.handleSelectNationalPlan}
                    handleForceNationalPlan={this.handleForceNationalPlan}
                    geo_json_data={this.state.geo_json_data}
                    addGeoJson={this.addGeoJson}
                    removeGeoJson={this.removeGeoJson}
                    selected_map_city_regions={this.state.selected_map_city_regions}
                    selected_map_state_regions={this.state.selected_map_state_regions}
                    selected_map_national_plan={this.state.selected_map_national_plan}
                  />
                )
              },
              {
                titleComponent: (
                  <Icon
                    color={this.state.currentStep == 1 ? '#F0C40B' : '#aaaaaa' }
                    style={{
                      ...iconStyle,
                      ...(
                        this.state.currentStep > 1 ?
                        {
                          color: '#ffffff',
                          borderColor: '#F0C40B',
                          backgroundColor: '#F0C40B'
                        } : {
                          backgroundColor: '#ffffff'
                        }
                      )
                    }}
                    name='database'
                  />
                ),
                bodyComponent: (
                  <DataPlanCalculator
                    plans={data_plans}
                    data_items={this.state.data_items}
                    handleIntervalChange={this.handleIntervalChange}
                    handleQuantityChange={this.handleQuantityChange}
                  />
                )
              },
              {
                titleComponent: (
                  <Icon
                    color={this.state.currentStep == 2 ? '#E56A3E' : '#aaaaaa' }
                    style={{
                      ...iconStyle,
                      ...(
                        this.state.currentStep > 2 ?
                        {
                          color: '#ffffff',
                          borderColor: '#E56A3E',
                          backgroundColor: '#E56A3E'
                        } : {
                          backgroundColor: '#ffffff'
                        }
                      )
                    }}
                    name='map-marker'
                   />
                ),
                bodyComponent: (
                  <CanvassingPlanCalculator
                    plans={canvassing_plans}
                    canvassing_items={this.state.canvassing_items}
                    handleIntervalChange={this.handleIntervalChange}
                    handleQuantityChange={this.handleQuantityChange}
                  />
                )
              },
              {
                titleComponent: (
                  <Icon
                    color={this.state.currentStep == 3 ? '#0088CC' : '#aaaaaa' }
                    style={{
                      ...iconStyle,
                      ...(
                        this.state.currentStep > 3 ?
                        {
                          color: '#ffffff',
                          borderColor: '#0088CC',
                          backgroundColor: '#0088CC'
                        } : {
                          backgroundColor: '#ffffff'
                        }
                      )
                    }}
                    name='shopping-cart'
                   />
                ),
                bodyComponent: (
                  <SubscriptionCheckout
                    subscriptions={this.props.subscriptions}
                    plans={this.props.plans}
                    map_interval={this.state.map_interval}
                    map_regions={this.state.map_regions}
                    selected_map_city_regions={this.state.selected_map_city_regions}
                    selected_map_state_regions={this.state.selected_map_state_regions}
                    selected_map_national_plan={this.state.selected_map_national_plan}
                    data_items={this.state.data_items}
                    canvassing_items={this.state.canvassing_items}
                    updating={this.state.updating}
                    handleCreate={this.handleCreate}
                    handleUpdate={this.handleUpdate}
                    resetPlanCalculator={() => this.setState({ currentStep: 0 })}
                    saving_subscription={this.props.saving_subscription}
                  />
                )
              }
            ]}
          />
        )}

        <ConfirmationPrompt
          show_condition={this.state.show_force_national_plan_prompt}
          handleCancelPrompt={() => this.confirmNationalPlan(false)}
          handleConfirmPrompt={() => this.confirmNationalPlan(true)}
          type='success'
          title=''
          body='You have purchased enough map regions to enable the national map plan. Your plan is being automatically updated.'
          confirm_button_text='Got It'
          cancel_button_text='Cancel'
        />
      </div>
    );
  }
}

PlanCalculator.PropTypes = {
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
};

module.exports = PlanCalculator;



// WEBPACK FOOTER //
// ./src/browser/components/settings/subscriptions/plans_calculator/section/PlanCalculator.js